import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import btnClose from '../../images/common/close.svg';
import {
  Main,
  Contents,
  BaseDialog,
  CloseButton,
  CloseButtonImage,
  UpdateButton,
} from '../../styles/common/Dialog';
import {
  DialogButton,
  DialogHeader,
  ButtonsContainer,
  MessageContainer,
} from '../Parts/styles/ConfirmationDialogStyles';
import useRestoreStaff from './hooks/useRestoreStaff';

/**
 * 削除状態のユーザーを復元するためのダイアログを表示する
 *
 * @param {Object} props
 * @param {Function} props.onCancel - ダイアログを閉じる関数
 */
const RestoreStaffDialog = ({ onCancel }) => {
  const { handleRestore, selectedUser } = useRestoreStaff(onCancel);

  return (
    <Main>
      <BaseDialog>
        <Contents>
          <DialogHeader>
            <FormattedMessage id="staff.restoreDialog.title" />
            <CloseButton
              id="closeButton"
              role="presentation"
              className="button"
              onClick={() => onCancel()}
            >
              <CloseButtonImage src={btnClose} alt="close" />
            </CloseButton>
          </DialogHeader>
          <MessageContainer>
            <FormattedMessage
              id="staff.restoreDialog.message"
              values={{ name: selectedUser.name }}
            />
          </MessageContainer>
          <ButtonsContainer>
            <DialogButton onClick={onCancel}>
              <FormattedMessage id="userPrompt.button.cancel" />
            </DialogButton>
            <UpdateButton onClick={handleRestore}>
              <FormattedMessage id="staff.restoreDialog.button.restore" />
            </UpdateButton>
          </ButtonsContainer>
        </Contents>
      </BaseDialog>
    </Main>
  );
};

RestoreStaffDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default RestoreStaffDialog;
